import Card from '../Components/Modals/Card';
import React, { useState, useEffect, navigate } from 'react';
import { apiClient } from '../services/api';
import { useSearchParams } from 'react-router-dom';
import currentDomain from '../Utils/Utils';
import { useNavigate } from 'react-router-dom';
import ButtonPrimary from '../Components/subcomponents/ButtonPrimary';
import CheckinConfirmationModal from '../Components/Modals/CheckinConfirmationModal';
import { toast } from 'react-toastify';

function Checkin() {
    const navigate = useNavigate();
    const [page, setPage] = React.useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [regData, setRegData] = React.useState([]);
    let phone = searchParams.get('phone') || '';


    const handleClick = (num) => {
        setSearchParams({ phone: phone + String(num) });
    }

    const handleDelete = () => {
        if (phone && phone.length > 0) {
            setSearchParams({ phone: phone.slice(0, -1) });
        }
    }


    const submitPhone = async () => {
        const response = await fetch(`${currentDomain(location)}/api/entries/phone/${phone}`, {
            method: 'GET',
        });
        if (!response.ok) {
            toast.error('Error fetching registration data. Is this a valid phone number?');
            return;
        }
        const resData = await response.json();
        if (resData && resData.length > 0) {
            setRegData(resData);
            setPage(1);
        } else {
            // Handle no data found case
            toast.error('No registration found for this phone number.');
        }
    }

    const confirmedEntry = () => {
        apiClient.sendTextMessage(2, [{owner_phone: regData[0].owner_phone, year: '', make: '', model: ''}]).then(() => {})
            setPage(0); 
            navigate('/checkin');
    }

    const goBack = () => {
        setPage(0);
    }

    const renderPage = () => {
        return (
            <Card>
                {page === 0 && (
                    <div>
                        <div className='m-4'>
                            <label className="pb-1 text-lg font-semibold"> Check-In by phone number </label>
                            <br />
                            <input
                                type="text"
                                value={phone || ''}
                                onChange={(e) => setSearchParams({ phone: e.target.value })}
                                placeholder="Enter phone number"
                                className="mt-1 block w-full px-3 py-2 border border-gray"
                            />
                        </div>
                        <div className="grid grid-cols-3 gap-4">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                <button
                                    key={num}
                                    onClick={() => handleClick(num)}
                                    className="bg-gray-100 hover:bg-gray-200 text-black font-bold py-4 px-4 rounded-md text-2xl"
                                >
                                    {num}
                                </button>
                            ))}
                            <button
                                onClick={handleDelete}
                                className="bg-red-100 hover:bg-red-200 text-black font-bold py-4 px-4 rounded-md text-2xl"
                            >
                                ←
                            </button>
                            <button
                                onClick={() => handleClick(0)}
                                className="bg-gray-100 hover:bg-gray-200 text-black font-bold py-4 px-4 rounded-md text-2xl"
                            >
                                0
                            </button>
                            <ButtonPrimary type="button" onClick={() => submitPhone()} className="col-span-3">
                                Continue
                            </ButtonPrimary>
                        </div>
                    </div>

                )}
                {page === 1 && (
                    <CheckinConfirmationModal
                        isOpen={true}
                        defaultValues={regData}
                        title="Confirm Registration Information"
                        onConfirm={() => confirmedEntry()}
                        onGoBack={() => goBack()}
                    />
                )}
            </Card>

        );
    };



    return renderPage();
}

export default Checkin;